// `chrome-extension.full-page-dialog.reports` — the route half of `packages/ui`'s
// `ReportsPage`. Routing and the one value the screen needs from the view model; nothing that
// draws (plan §2.3).
import { useEffect, useState, type ReactElement } from 'react'
import { fetchViewModel } from '@woo-ext/api'
import { getAtsLabel, ReportsPage } from '@woo-ext/ui'

/**
 * ⚠️ THIS SCREEN TAKES A MINUTE TO FINISH LOADING, by design rather than by fault.
 * `generateEnrichmentReport` fires on mount and measures 60.01s against a real tenant — it
 * builds a report over every candidate. The proxy's timeout had to be raised from
 * `reply-from`'s 10s default for it (`ddd2eb8`), and anything that waits on this page — a
 * capture, a smoke test — needs a budget past a minute or it photographs the spinner.
 */
export function ReportsRoute(): ReactElement {
  const [atsName, setAtsName] = useState<string | undefined>(undefined)
  const [atsLabel, setAtsLabel] = useState<string | undefined>(undefined)

  useEffect(() => {
    let live = true
    fetchViewModel().then(
      (model) => {
        if (!live) return
        setAtsName(model.atsName ?? undefined)
        setAtsLabel(getAtsLabel(model))
      },
      () => undefined,
    )
    return () => {
      live = false
    }
  }, [])

  return (
    <ReportsPage
      {...(atsName === undefined ? {} : { atsName })}
      {...(atsLabel === undefined ? {} : { atsLabel })}
    />
  )
}
